import { api } from './api';
import type {
  PromptRunResponse,
  PromptExecuteRequest,
  PromptAdhocRequest,
} from '../types';

// API Response wrapper type (single-object envelope → response.data.data)
interface ApiResponse<T> {
  success: boolean;
  code: number;
  message: string;
  data: T;
}

export const promptRunService = {
  /** Run a stored prompt. perm: PROMPT_EXECUTION.EXECUTE */
  execute: async (
    promptId: string,
    body: PromptExecuteRequest
  ): Promise<PromptRunResponse> => {
    const response = await api.post<ApiResponse<PromptRunResponse>>(
      `/api/v1/prompts/${promptId}/execute`,
      body
    );
    return response.data.data;
  },

  /** Ad-hoc prompt run (persists nothing). perm: PROMPT_EXECUTION.EXECUTE */
  executeAdhoc: async (body: PromptAdhocRequest): Promise<PromptRunResponse> => {
    const response = await api.post<ApiResponse<PromptRunResponse>>(
      '/api/v1/prompts/execute-adhoc',
      body
    );
    return response.data.data;
  },
};
